var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4C4C",
    fillRule: "evenodd",
    d: "M2.98 13.67a1.333 1.333 0 0 1-1.154-2l5.02-8.674a1.333 1.333 0 0 1 2.307 0l5.02 8.673c.513.887-.127 2-1.153 2zm5.452-9.26a.5.5 0 0 0-.865 0l-4.153 7.175a.5.5 0 0 0 .433.75h8.305a.5.5 0 0 0 .433-.75zM7.333 7.5v1.667c0 .458.3.833.667.833.366 0 .666-.375.666-.833V7.5c0-.458-.3-.833-.666-.833s-.667.375-.667.833M8 10.336a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;